import { createContext, useContext, useState, useCallback, ReactNode } from "react";

export type AppMode = "orderbooks" | "predictions";

interface AppModeContextProps {
  mode: AppMode;
  setMode: (mode: AppMode) => void;
}

const STORAGE_KEY = "app_mode";

function getInitialMode(): AppMode {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "orderbooks" || stored === "predictions") return stored;
  return "orderbooks";
}

const AppModeContext = createContext<AppModeContextProps | undefined>(undefined);

export const AppModeProvider = ({ children }: { children: ReactNode }) => {
  const [mode, setModeState] = useState<AppMode>(getInitialMode);

  const setMode = useCallback((newMode: AppMode) => {
    setModeState(newMode);
    localStorage.setItem(STORAGE_KEY, newMode);
  }, []);

  return (
    <AppModeContext.Provider value={{ mode, setMode }}>
      {children}
    </AppModeContext.Provider>
  );
};

export const useAppMode = () => {
  const context = useContext(AppModeContext);
  if (!context) {
    throw new Error("useAppMode must be used within an AppModeProvider");
  }
  return context;
};
